function initiateEditTextBlock (e) {
  if (e.diagram.tdsPartCreated) {
    e.diagram.commandHandler.editTextBlock(e.diagram.tdsPartCreated)
    e.diagram.tdsPartCreated = null
  } else {
    e.diagram.commandHandler.editTextBlock()
  }
}

function startEditingOnAnimationFinished (e) {
  if (e) {
    e.diagram.removeDiagramListener('AnimationFinished', startEditingOnAnimationFinished)
  }
  initiateEditTextBlock(e)
}

function startEditingOnLayoutCompleted (e) {
  if (e) {
    e.diagram.removeDiagramListener('LayoutCompleted', startEditingOnLayoutCompleted)
  }
  initiateEditTextBlock(e)
}

export { startEditingOnAnimationFinished, startEditingOnLayoutCompleted }



// WEBPACK FOOTER //
// ./src/graph_parts/editing_text.js